import React from 'react';
import StudentsSelector from './StudentsSelector';
import StudentInfo from './StudentInfo';
import LogsInfo from './LogsInfo';
import useMarkingClasses from '../MarkingClassesContext/MarkingClassesHook';
import WorkedExamples from '../WorkedExamples/WorkedExamples';
import GrowthGoals from '../GrowthGoals/GrowthGoals';
import { useSelector } from 'react-redux';
import LegendLearningGrowth from '../LearningGrowth/Legend';

const StudentData = ({ type = 'student-view' }) => {
  const { viewSelector } = useMarkingClasses();
  const student = useSelector((state) => state?.classMarking.student);
  return (
    <>
      <div className='bg-background max-w-200px min-w-200px absolute inset-y-0 z-20 relative'>
        <div className='flex flex-col gap-2 py-2 pr-2 h-200px'>
          <StudentsSelector type={type} />
          <StudentInfo type={type} />
        </div>
      </div>
      {type === 'student-view' && student?._id && viewSelector === 'logs' && <LogsInfo />}
      {type === 'student-view' && student?._id && viewSelector === 'worked-examples' && <WorkedExamples />}
      {type === 'student-view' && student?._id && viewSelector === 'growth-goals' && <GrowthGoals />}
      {type === 'learning-growth' && <LegendLearningGrowth />}
      </>
  );
};

export default StudentData;
